import { forEach, isElement, isNil, isString } from "lodash";

const
    selectors = {
        base: ".js-ad"
    };

/**
 * JS module for Google Advertisements in golf.nl platform
 */
export default class Advertisement {

    constructor(baseElement) {
        if (typeof googletag === "undefined") {
            return false;
        }

        if (!isElement(baseElement)
            || isNil(baseElement.id)
            || isNil(baseElement.dataset.slot)
            || !isString(baseElement.dataset.dimensions)
            || (!isNil(baseElement.dataset.sizemapping) && !isString(baseElement.dataset.sizemapping))
            ) {
            return // Insufficient data to render slot. Required: element with id, data-slot and data-dimensions specified. The data-sizemapping is optional, but if present must be a string
        }

        this._config(baseElement);
        this._setup();

    }

    _pushAds() {
        googletag.cmd.push(() => {
            const mapping = googletag.sizeMapping();

            for (let i = 0; i < this.sizemappings.length - 1; i = i + 2) {
                mapping.addSize(this.sizemappings[i], this.sizemappings[i + 1]);
            }

            googletag
                .defineSlot(this.slot, this.dimensions, this.id)
                .defineSizeMapping(mapping.build())
                .addService(googletag.pubads());
        });

        googletag.cmd.push(() => { googletag.display(this.id); })
    }

    _removeAds() {
        if (!isNil(googletag.destroySlots)) {
            googletag.destroySlots();
        }
    }

    _bindEvents() {
        window.addEventListener('CookiebotOnAccept', (e) => {
            if (Cookiebot.consent.marketing) {
                this._pushAds();
            } else {
                this._removeAds();
            }
        });
        window.addEventListener('CookiebotOnDecline', (e) => {
            if (!Cookiebot.consent.marketing) {
                this._removeAds();
            }
        });
    }

    _config(baseElement) {
        this.id = baseElement.id;
        this.slot = baseElement.dataset.slot;
        this.dimensions = JSON.parse(baseElement.dataset.dimensions);
        this.sizemappings = JSON.parse(baseElement.dataset.sizemapping);
    }

    _setup() {
        this._bindEvents();
    }
}

forEach(document.querySelectorAll(selectors.base), adItem => {
    new Advertisement(adItem);
});